import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth0Service } from '../services/auth0.service';
import { LOGIN_PATH } from '../../../../apps/values/path';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const IsLoggedInGuard: CanActivateFn = (
  route,
  state
): Observable<boolean> => {
  const auth0Service = inject(Auth0Service);
  const router = inject(Router);

  return auth0Service.isAuthenticated$.pipe(
    take(1),
    map((isAuthenticated) => {
      if (isAuthenticated) {
        return true;
      }
      const LOGIN_ROUTE_PATH = `/${LOGIN_PATH}`;
      router.navigate([LOGIN_ROUTE_PATH]);
      return false;
    })
  );
};
